const currentYear = new Date().getFullYear();

const locale = {
    code: "es",
    label: "Español",
    NAV_BAR: {
        home: "Inicio",
        homeId: "home",
        aboutus: "Sobre Nosotros",
        aboutId: "aboutus",
        faq: "Preguntas",
        faqId: "faq-section",
        contact: "Contacto",
        contactId: "contact-section",
        button: "Obtener Acceso",
    },

    HERO: {
        heroHeading: "Tu menú, accesible al instante",
        heroParagraph:
            "Crea, actualiza y comparte tu menú con un solo código QR: sin complicaciones, sin reimpresiones.",
        button: "Obtener Acceso",
        downloadText: "Descargar en",
        appStore: "App Store",
        getItOn: "OBTÉNLO EN",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Nuestros Servicios",
        cards: [
            {
                title: "Crear y subir menú",
                description:
                    "Crea y sube tu menú fácilmente con unos pocos clics. Añade productos, establece precios y actualiza detalles sin necesidad de conocimientos técnicos.",
            },
            {
                title: "Actualizar menú",
                description:
                    "Actualiza tu menú en tiempo real cuando quieras. Cambia precios, agrega nuevos platos o archiva elementos no disponibles al instante sin reimpresión.",
            },
            {
                title: "Generar y compartir",
                description:
                    "Genera un código QR único para tu menú al instante. Compártelo en mesas, carteles o en línea para que los clientes lo escaneen y accedan a tu menú más reciente.",
            },
        ],
    },

    FEATURES: {
        heading: "Descubre nuestras increíbles funciones",
        lists: [
            {
                title: "Gestionar menú",
                description:
                    "Administra tu menú en cualquier momento. Agrega, edita o elimina elementos con facilidad para mantener tu oferta actualizada.",
            },
            {
                title: "Informes e ideas",
                description:
                    "Obtén información valiosa con informes en tiempo real. Rastrea vistas del menú, escaneos de QR y la interacción de los clientes.",
            },
            {
                title: "Compartir códigos QR",
                description:
                    "Comparte tu menú con un código QR único. Muéstralo en mesas, carteles o en línea para que los clientes lo escaneen fácilmente.",
            },
            {
                title: "Reseñas de clientes",
                description:
                    "Muestra comentarios reales de clientes y calificaciones. Genera confianza, mejora tu menú y brinda una mejor experiencia gastronómica.",
            },
            {
                title: "Ofertas y descuentos",
                description:
                    "Aumenta las ventas con ofertas especiales y descuentos. Destaca promociones de tiempo limitado y descuentos exclusivos.",
            },
        ],
    },

    ABOUT: {
        heading: "Acerca de My QR Menu",
        headingPara: "Simplifica la gestión del menú de tu restaurante con actualizaciones en tiempo real.",
        highlightHeading: "Acceso rápido y fácil a todo lo que necesitas",
        highlightPara: "Todas tus funciones de menú, con un solo toque.",
        cards: {
            left: {
                heading: ["Agrega ingredientes", "fácilmente a tu menú QR"],
                alt: "Agregar ingredientes",
            },
            right: {
                heading: ["Accede a tu", "panel de menú fácilmente"],
                alt: "Panel de menú",
            },
        },
    },

    FAQ: {
        heading: "Tienes preguntas. Tenemos respuestas.",
        subheading: "Todo lo que necesitas saber sobre el producto.",
        items: [
            {
                question: "¿Qué es My QRMenu?",
                answer:
                    "My QRMenu es una plataforma de menú digital que permite a los restaurantes crear, actualizar y compartir sus menús al instante con códigos QR.",
            },
            {
                question: "¿Puedo actualizar mi menú después de crearlo?",
                answer:
                    "Sí, puedes actualizar tu menú en cualquier momento y se mostrará instantáneamente cuando los clientes escaneen tu código QR.",
            },
            {
                question: "¿Cómo funciona My QRMenu?",
                answer:
                    "Creas un menú, generas un código QR y los clientes lo escanean para ver la versión más reciente de tu menú.",
            },
            {
                question: "¿Cómo comparto mi código QR?",
                answer:
                    "Puedes compartir el código QR digitalmente o imprimirlo para mostrarlo en tu restaurante.",
            },
            {
                question: "¿My QRMenu es compatible con dispositivos móviles?",
                answer:
                    "Sí, My QRMenu está optimizado para todos los dispositivos, incluidos teléfonos móviles y tabletas.",
            },
            {
                question: "¿Puedo recopilar reseñas de clientes?",
                answer:
                    "Sí, puedes habilitar reseñas de clientes y usar los comentarios para mejorar tu oferta.",
            },
        ],
    },

    CONTACT: {
        heading: "Contáctanos",
        subheading: "Nuestro equipo amable estará encantado de escucharte.",
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Correo electrónico",
        message: "Mensaje",
        firstNamePlaceholder: "Nombre",
        lastNamePlaceholder: "Apellido",
        emailPlaceholder: "tú@empresa.com",
        messagePlaceholder: "Escribe tu mensaje...",
        privacyConsent: "Aceptas nuestra",
        privacyPolicy: "política de privacidad",
        submitButton: "Enviar mensaje",
        toast: {
            requiredConsent: "Debes aceptar la política de privacidad.",
            submitting: "Enviando mensaje...",
            success: "¡Mensaje enviado con éxito!",
            fail: "No se pudo enviar el mensaje. Por favor, inténtalo de nuevo.",
            error: "Ocurrió un error. Por favor, verifica tu conexión.",
        },
    },

    HELP_PAGE: {
        title: "Centro de Ayuda",
        description: "Si tienes alguna pregunta o necesitas ayuda, contáctanos en ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "O revisa nuestras preguntas frecuentes a continuación, podrías encontrar lo que buscas.",
    },

    FOOTER: {
        footerHeading: "Menús digitales sin fisuras, simplificados.",
        footerButton: "Únete a la lista de espera",
        footerConnect: "Conéctate con nosotros",
        footerTerms: "Términos y acuerdos",
        footerHelp: "Centro de ayuda",
        footerPrivacy: "Política de privacidad",
        footerCopyright: `©${currentYear} Todos los derechos reservados.`,
    },

    PRIVACY_POLICY: {
        title: "Política de Privacidad",
        lastUpdated: "Última actualización: 22 de mayo de 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Esta Política de Privacidad describe Nuestras políticas y procedimientos sobre la recopilación, el uso y la divulgación de Su información cuando utiliza el Servicio.
                </p>
                <p class="mb-6 leading-relaxed">
                Utilizamos Sus datos personales para proporcionar y mejorar el Servicio. Al utilizar el Servicio, Usted acepta la recopilación y el uso de información de acuerdo con esta Política de Privacidad.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interpretación y Definiciones</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interpretación</h3>
                <p class="mb-6 leading-relaxed">
                    Las palabras cuya letra inicial está en mayúscula tienen significados definidos bajo las siguientes condiciones.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Definiciones</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Cuenta</strong> significa una cuenta única creada para que Usted acceda a nuestro Servicio.</li>
                    <li><strong>Compañía</strong> se refiere a <strong>My QR Menu,</strong> Londres, Reino Unido.</li>
                    <li><strong>Datos Personales</strong> es cualquier información que se relacione con un individuo identificado o identificable.</li>
                    <li><strong>Usted</strong> significa el individuo que accede o utiliza el Servicio.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Contáctenos</h2>
                <p>
                Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>Por correo electrónico: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Términos y Condiciones",
        lastUpdated: "Última actualización: 22 de mayo de 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Lea estos Términos y Condiciones detenidamente antes de utilizar nuestra Aplicación o Sitio Web.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interpretación y Definiciones</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interpretación</h3>
            <p class="leading-relaxed mb-4">
            Las palabras cuya letra inicial está en mayúscula tienen significados definidos bajo las siguientes condiciones.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Definiciones</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Aplicación</strong> significa el software proporcionado por My QR Menu.</li>
            <li><strong>Compañía</strong> se refiere a My QR Menu, con sede en Londres, Reino Unido.</li>
            <li><strong>Servicio</strong> se refiere a la Aplicación y al Sitio Web.</li>
            <li><strong>Usted</strong> significa el individuo o empresa que accede al Servicio.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Reconocimiento</h2>
            <p class="leading-relaxed mb-6">
            Al acceder o utilizar el Servicio, Usted acepta estar sujeto a estos Términos. Si no está de acuerdo con alguna parte, no podrá acceder al Servicio.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Enlaces a Otros Sitios Web</h2>
            <p class="leading-relaxed mb-6">
            Nuestro Servicio puede contener enlaces a sitios web de terceros. No asumimos responsabilidad por su contenido o prácticas.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Terminación</h2>
            <p class="leading-relaxed mb-6">
            Nos reservamos el derecho de terminar o suspender Su acceso al Servicio de inmediato, sin previo aviso, por cualquier motivo.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Limitación de Responsabilidad</h2>
            <p class="leading-relaxed mb-6">
            En la medida máxima permitida por la ley, la Compañía no será responsable por ningún daño derivado del uso del Servicio.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. Descargo de Responsabilidad "TAL CUAL" y "SEGÚN DISPONIBILIDAD"</h2>
            <p class="leading-relaxed mb-6">
            El Servicio se le proporciona "TAL CUAL" y "SEGÚN DISPONIBILIDAD". No garantizamos que esté libre de errores o interrupciones.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Ley Aplicable</h2>
            <p class="leading-relaxed mb-6">
            Estos Términos se regirán por las leyes del Reino Unido.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Resolución de Disputas</h2>
            <p class="leading-relaxed mb-6">
            Si tiene una disputa con nosotros, acepta intentar resolverla de manera informal antes de emprender acciones legales.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Para Usuarios de la Unión Europea (UE)</h2>
            <p class="leading-relaxed mb-6">
            Si es un consumidor en la UE, tiene derecho a la protección de las disposiciones obligatorias de la ley de su país de residencia.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Cumplimiento Legal en los Estados Unidos</h2>
            <p class="leading-relaxed mb-6">
            Usted declara y garantiza que no se encuentra en un país sujeto a sanciones del gobierno de los EE. UU.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Divisibilidad y Renuncia</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Divisibilidad</h3>
            <p class="leading-relaxed mb-4">
            Si alguna disposición de estos Términos se considera inaplicable, las disposiciones restantes permanecerán en vigor.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Renuncia</h3>
            <p class="leading-relaxed mb-6">
            El hecho de no hacer cumplir una disposición no constituirá una renuncia a tal derecho.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Interpretación de la Traducción</h2>
            <p class="leading-relaxed mb-6">
            Es posible que estos Términos hayan sido traducidos. En caso de disputa, prevalecerá la versión en inglés.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Cambios a estos Términos</h2>
            <p class="leading-relaxed mb-6">
            Podemos actualizar estos Términos en cualquier momento. Le notificaremos publicando un aviso en nuestro Sitio Web.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Contáctenos</h2>
            <p class="leading-relaxed mb-2">Si tiene preguntas sobre estos Términos, puede contactarnos:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>Por correo electrónico: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
